(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractOnlinePaymentDeleteController',ContractOnlinePaymentDeleteController);

    ContractOnlinePaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function ContractOnlinePaymentDeleteController($uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.onlinePayment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
        	Contrat.deleteOnlinePayment({idOnlinePayment: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
